
import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useLocation } from "react-router-dom";
import AppLayout from "./AppLayout";

interface ConditionalAppLayoutProps {
  children: ReactNode;
}

export const ConditionalAppLayout = ({ children }: ConditionalAppLayoutProps) => {
  const { isAuthenticated, isLoading, session, validateSession } = useAuth();
  const location = useLocation();

  console.log('[ConditionalAppLayout] State:', { 
    isAuthenticated, 
    isLoading, 
    hasSession: !!session,
    currentPath: location.pathname 
  });

  // Enhanced loading state with timeout protection
  if (isLoading) {
    console.log('[ConditionalAppLayout] Showing auth loading state');
    
    // Add timeout protection to prevent infinite loading
    setTimeout(() => {
      if (isLoading) {
        console.warn('[ConditionalAppLayout] Loading timeout detected, validating session');
        validateSession();
      }
    }, 10000);
    
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center space-y-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="text-muted-foreground">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Enhanced authentication check with session validation
  if (isAuthenticated && session) {
    // Pages that should render without the main app layout
    const noLayoutPages = ['/onboarding'];
    
    if (noLayoutPages.includes(location.pathname)) {
      console.log('[ConditionalAppLayout] Rendering without layout for:', location.pathname);
      return <>{children}</>;
    }
    
    console.log('[ConditionalAppLayout] Rendering with AppLayout for authenticated user');
    return <AppLayout>{children}</AppLayout>;
  }

  // If not authenticated or no session, render children directly (no nav/sidebar)
  console.log('[ConditionalAppLayout] Rendering without layout for unauthenticated user');
  return <>{children}</>;
};
